import { createWeb3Modal } from '@web3modal/wagmi/react';
import { wagmiConfig, projectId } from './wagmi';

createWeb3Modal({
  wagmiConfig,
  projectId,
  themeMode: 'dark',
  themeVariables: {
    '--w3m-accent': '#3b82f6',
  },
});
